import { Typography } from "@mui/material"
import Chip from "@mui/material/Chip"

export const COLUMNSEVALUACIONESPENDIENTES = [
  {
    accessorKey: "id",
  },
  {
    header: "Evaluado",
    accessorKey: "_new_evaluado_value",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Tipo de Evaluación",
    accessorKey: "new_tipodeevaluacion",
    Cell: ({ cell }) => {
      switch (cell.getValue()) {
        case "Coevaluación":
          return <Chip label="Coevaluación" sx={{ fontWeight: "bold" }} color="secondary" variant="outlined" />
        case "Autoevaluación":
          return <Chip label="Autoevaluación" sx={{ fontWeight: "bold" }} color="secondary" variant="outlined" />
      }
    },
  },
  {
    header: "Período",
    accessorKey: "_new_periodo_value",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Materia",
    accessorKey: "_new_materia_value",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha de Vencimiento",
    accessorKey: "new_fechadevencimiento",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
]

export const COLUMNSMISEVALUACIONESCOMPVEN = [
  {
    header: "Evaluado",
    accessorKey: "_new_evaluado_value",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Tipo de Evaluación",
    accessorKey: "new_tipodeevaluacion",
    Cell: ({ cell }) => {
      switch (cell.getValue()) {
        case "Coevaluación":
          return <Chip label="Coevaluación" sx={{ fontWeight: "bold" }} color="secondary" variant="outlined" />
        case "Autoevaluación":
          return <Chip label="Autoevaluación" sx={{ fontWeight: "bold" }} color="secondary" variant="outlined" />
      }
    },
  },
  {
    header: "Período",
    accessorKey: "_new_periodo_value",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Materia",
    accessorKey: "_new_materia_value",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Valoración final",
    accessorKey: "new_valoracionfinal",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Estado",
    accessorKey: "statuscode",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
]

export const getCOLUMNSITEMSEVALUACION = (handleAbrirModal) => [
  {
    accessorKey: "id",
  },
  {
    header: "Competencia",
    accessorKey: "competencia",
    Cell: ({ row, cell }) => (
      <Chip 
        label={cell.getValue()} 
        sx={{ fontWeight: "bold" }} 
        color="success" 
        variant="outlined" 
        onClick={() => handleAbrirModal(row.original.competencia, row.original.descripcion, row.original)} 
      />
    ),
  },
  {
    header: "Autoevaluacion",
    accessorKey: "valoracionModal?.label",
    Cell: ({ row }) => (
      <strong>{row.original.valoracionModal?.label}</strong>
    ),
  },
  {
    header: "Valoracion Lider",
    accessorKey: "valoracionLiderModal?.label",
    Cell: ({ row }) => (
      <strong>{row.original.valoracionLiderModal?.label}</strong>
    ),
  },
]

export const COLUMNSENCUESTAS = [
  {
    header: "Evaluado",
    accessorKey: "new_evaluado",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Materia",
    accessorKey: "_new_materia_value",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Período",
    accessorKey: "_new_periodo_value",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Modalidad",
    accessorKey: "new_modalidad",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Sección",
    accessorKey: "new_seccion",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
]
